import { SVGProps, Ref, forwardRef } from 'react';

export const EmptySize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <rect x={-1} y={-1} width={18} height={18} stroke="currentColor" strokeWidth={2} />
            </g>
        </g>
    </svg>
));
EmptySize16Glyph.displayName = 'EmptySize16Glyph';
